import { SystemPopupTypes } from 'store/systemPopup/systemPopupSlice';

import { CreditsInsufficientPopup } from './submodules/CreditsInsufficientPopup';
import { CreditsPurcasedPopup } from './submodules/CreditsPurcasedPopup';
import { CreditsRefillPopup } from './submodules/CreditsRefillPopup';
import { CreditsWelcomeGiftPopup } from './submodules/CreditsWelcomeGiftPopup';

export const SYSTEM_POPUPS_MAP = {
  [SystemPopupTypes.CreditsPurcased]: CreditsPurcasedPopup,
  [SystemPopupTypes.CreditsWelcomeGift]: CreditsWelcomeGiftPopup,
  [SystemPopupTypes.CreditsInsufficient]: CreditsInsufficientPopup,
  [SystemPopupTypes.CreditsRefill]: CreditsRefillPopup,
};
